<script>
import compoment from '@/components/draggable/SmartComponents/basicComponents/Sinput/SInputPreview'
export default {
  name: 'SEmailPreview',
  extends: compoment
}
</script>
